import React from 'react';
import PropTypes from 'prop-types';
import { isNumeric, isUuid, createCustomPropType } from '../../../js/app/react/validators';
import { ESTATE_FLOW, GET_TITLE } from './ExplanationsConst';
import { LONGEVITY_ANALYSIS } from '../Retirement/RetirementConstants';
import { Text } from '../../CommonComponents/OPL/Text/Text';

const ExplanationsView = ({
  sections,
  goalId,
  clientId,
  recommendationTitle,
  selectedSection,
  setSelectedSection,
  noTabs,
  recommendationMessage,
}) => {
  return (
    <section
      style={{
        ...(selectedSection === LONGEVITY_ANALYSIS
          ? {
              marginBottom: '0',
              borderBottomLeftRadius: '0',
              borderBottomRightRadius: '0',
            }
          : {}),
      }}
      className={
        noTabs
          ? 'financial-plan-explanations-section-no-tabs'
          : 'financial-plan-explanations-section'
      }
    >
      {!noTabs && (
        <ul className="financial-plan-explanations-section-ul">
          {sections.map(section => (
            <li key={section} className="financial-plan-explanations-section-li">
              <button
                type="button"
                onClick={setSelectedSection(goalId, section, clientId)}
                className={
                  selectedSection === section
                    ? 'financial-plan-explanations-section-button selected'
                    : 'financial-plan-explanations-section-button'
                }
                aria-expanded={selectedSection === section}
              >
                {GET_TITLE(section)}
              </button>
            </li>
          ))}
        </ul>
      )}
      {selectedSection !== ESTATE_FLOW && selectedSection !== LONGEVITY_ANALYSIS && (
        <div className="recommendations-container">
          <Text fontWeight={600} color="neutral.600" fontSize="h4" lineHeight={1}>
            {recommendationTitle}
          </Text>
          <p className="financial-plan-explanations-section-message">{recommendationMessage}</p>
        </div>
      )}
    </section>
  );
};

ExplanationsView.defaultProps = {
  selectedSection: null,
};

ExplanationsView.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  recommendationMessage: PropTypes.string.isRequired,
  recommendationTitle: PropTypes.string.isRequired,
  selectedSection: PropTypes.string,
  noTabs: PropTypes.bool.isRequired,
  setSelectedSection: PropTypes.func.isRequired,
};

export default ExplanationsView;
